import _ from 'lodash'
import { AutoComplete } from 'primereact/autocomplete'
import { InputText } from 'primereact/inputtext'
import { useEffect, useState } from 'react'

import { Flex } from '../../../../Components'
import { FC } from '../../../../Services'
import { cap } from '../../../../State'
import { isFieldNotRequired, readKey } from '../Functions'
import { getColorDiff } from './Functions'
import { useTransferField } from './Hook'

const language = (cap.language.state || 'it').toLowerCase()

export const StationInput = ({ state: [state, setState], item, count, readOnly, diffStatus }) => {
  const { location, label, id, limitLength } = item
  let [data, setData] = useTransferField([state, setState], location, count)
  const skipTrainSearch = readKey(
    state,
    'transferInfo.infoPax.listOfPax.0.infoServices.train.#COUNT.skipTrainSearch',
    count
  )
  const [error, setError] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const maxLength = limitLength && limitLength > 0 ? limitLength : undefined

  useEffect(() => {
    setError(!data && !skipTrainSearch && !isFieldNotRequired(state, item))
  }, [data, skipTrainSearch, state, item])
  const debounceSearch = _.debounce(async ({ query }) => {
    if (query?.length < 3) return setSuggestions([])
    const res = await FC.service('info').get('getTrainStation', { query: { inputTrain: query } })
    setSuggestions(res?.slice(0, 10))
  }, 1000)
  if (typeof data === 'object' && !Object.keys(data || {}).length) data = ''
  return (
    <Flex key={item.id} as js style={{ width: '23%', margin: '5px 1%' }}>
      <div className="nfield" style={{ marginTop: 25, width: '100%' }}>
        <span className="p-float-label">
          {!skipTrainSearch ? ( // gestione della ricerca delle stazioni, se non è skip, devo fare autocomplete, altrimenti campo libero
            <AutoComplete
              disabled={readOnly}
              className={error ? 'p-invalid' : ''}
              id={id}
              onSelect={(e) => setData(e.value)}
              field="stationName"
              value={data}
              suggestions={suggestions}
              completeMethod={debounceSearch}
              onChange={(e) => setData(e.value)}
              inputStyle={{
                fontFamily: 'var(--font-family)',
                width: '100%',
                color: getColorDiff(diffStatus, error)
              }}
              style={{ width: '100%' }}
              forceSelection
              inputProps={{ maxLength }}
            />
          ) : (
            <InputText
              style={{
                fontFamily: 'var(--font-family)',
                fontSize: 14,
                width: '100%',
                color: getColorDiff(diffStatus, error)
              }}
              id={id}
              onChange={(e) => {
                setData(e.target.value)
              }}
              value={data || ''}
              className={error ? 'p-invalid' : ''}
              disabled={readOnly}
              maxLength={maxLength}
            />
          )}
          <label
            style={{ fontFamily: 'var(--font-family)', color: getColorDiff(diffStatus, error) }}
          >
            {label?.[language] || label?.it}
          </label>
        </span>
      </div>
    </Flex>
  )
}
